export const supportedLocales = {
    en: "English",
    es: "Spanish",
}

export const fallbackLocale = "es";
